import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '../auth/auth.service';
import { ShellFacade } from '../shell/shell.facade';

export const AuthGuard: CanActivateFn = () => {
  const _shellFacade: ShellFacade = inject(ShellFacade);
  _shellFacade.updateProfile(JSON.parse(sessionStorage.getItem('profile')!));

  return inject(AuthService).isAuthenticated() ? true : inject(Router).navigate(['/auth/login']);
};
